import React from 'react';
import PropTypes from 'prop-types';
import Avatar from '@mui/material/Avatar';
import Chip from '@mui/material/Chip';

class DepotGestion extends React.Component {

    render() {

        const { depotGestion, format } = this.props;

        let _format = format;
        if (!_format) {
            _format = "simple";
        }
        
        var str = `${depotGestion.codeDepot} - ${depotGestion.nom}`;
        
        if (_format === "simple") {
            return str;
        }
                
        if (_format === "deletablechip") {
            return (
                <Chip
                    avatar={<Avatar>{depotGestion.codeDepot}</Avatar>}
                    label={depotGestion.nom}
                    onDelete={this.props.onDelete}
                />
            );
        }
        
        return str;
    }
}

DepotGestion.propTypes = {
    format: PropTypes.string,
    depotGestion: PropTypes.object.isRequired,
    onDelete: PropTypes.func
};

export default DepotGestion;